
  <div [ngClass]="field.fieldSize? 'col-md-' + field.fieldSize : ''" style="display: inline-block;">
    <div class="wrap w-100" [matTooltip]="field.hint" [matTooltipDisabled]="!field.hint"
      matTooltipPosition="above" matTooltipClass="sbm-tooltip">
      <div class="title">
      <ng-container *ngIf="field.sequence>=0 && !field.hideSequence"> {{field.sequence + 1}}) </ng-container>
        {{field.label}}</div>
      <div>{{group.get(field.name).value}}</div>
    </div>
  </div>
